'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconMessagesBubble = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12 1.337C5.659 1.337.5 5.587.5 10.811a8.6 8.6 0 0 0 3.175 6.54l-2.3 4.587a.5.5 0 0 0 .659.677l6.149-2.862a13.717 13.717 0 0 0 3.817.533c6.341 0 11.5-4.25 11.5-9.475S18.341 1.337 12 1.337z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1.5 23.5a.5.5 0 0 1-.462-.692l2.256-5.413A9.215 9.215 0 0 1 0 10.51C0 4.988 5.383.5 12 .5s12 4.486 12 10-5.383 10-12 10c-1.38 0-2.749-.202-4.068-.599l-6.183 3.533a.507.507 0 0 1-.249.066zM12 1.5c-6.065 0-11 4.037-11 9a8.192 8.192 0 0 0 3.205 6.345.5.5 0 0 1 .156.588l-1.836 4.405 5.098-2.913a.5.5 0 0 1 .399-.043c1.288.41 2.626.618 3.978.618 6.065 0 11-4.037 11-9s-4.935-9-11-9z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M.748 24a.75.75 0 0 1-.678-1.072l2.911-6.113a11.245 11.245 0 0 1-1.484-5.596C1.507 5.033 6.547 0 12.733 0h.034c2.101 0 4.155.587 5.94 1.696a11.172 11.172 0 0 1 5.011 7c.683 2.93.187 5.946-1.397 8.494a11.176 11.176 0 0 1-6.998 5.016 11.208 11.208 0 0 1-8.139-1.189l-6.112 2.911A.777.777 0 0 1 .748 24zM12.733 1.5c-5.36 0-9.727 4.361-9.735 9.721a9.724 9.724 0 0 0 1.47 5.158.745.745 0 0 1 .04.719l-2.174 4.567L6.9 19.49a.747.747 0 0 1 .718.041 9.71 9.71 0 0 0 7.362 1.214 9.69 9.69 0 0 0 6.066-4.347c2.839-4.566 1.434-10.59-3.132-13.428a9.74 9.74 0 0 0-5.148-1.47h-.033z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconMessagesBubble.displayName = 'IconMessagesBubble';
exports.default = IconMessagesBubble;